import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AccessService } from '@app-core/services/access/access.service';
import { getClientConfig } from '@config/client-config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LandingPageGuard implements CanActivate {
  public clientConfig = getClientConfig().configuration;
  constructor(private accessService: AccessService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.clientConfig.showLandingPage || this.accessService.isUserAuthenticated()) {
      return this.callbackUrlTree;
    }

    if (this.clientConfig.showCustomLoginPage) {
      return this.router.parseUrl('custom-login');
    }

    return true;
  }

  private get callbackUrlTree(): UrlTree {
    const url = this.clientConfig.wildcardRoute;
    const tree = this.router.parseUrl(url);
    return tree;
  }
}
